import { Subscribable, Subscription } from '@benzinga/subscribable';
import { Holding } from './entities';
import { Session } from '@benzinga/session';
import { HoldingsRequest } from './request';
import { oneRequestAtATime } from '@benzinga/utils';
import { HoldingsStore } from './store';

export interface HoldingsGetRequestEvent {
  indexHoldings: Holding[];
  type: 'holdings:get_holdings';
}

export interface HoldingsErrorEvent {
  error: Error | string;
  type: 'holdings:error_holdings';
}

export interface HoldingsUpdateEvent {
  type: 'holdings:update_holdings';
  indexHoldings: Holding[];
}

export type HoldingsRequestEvent = HoldingsGetRequestEvent | HoldingsErrorEvent | HoldingsUpdateEvent;

export class HoldingsManager extends Subscribable<HoldingsRequestEvent> {
  private request: HoldingsRequest;
  private store = new HoldingsStore();
  private storeSubscription?: Subscription<HoldingsStore>;
  private requestSubscription?: Subscription<HoldingsRequest>;
  private fetchHolding = oneRequestAtATime(async () => {
    const indexHoldings = await this.request.getHoldings();
    if (indexHoldings.err) {
      return indexHoldings.err;
    } else {
      return this.store.updateHoldings(indexHoldings.ok ?? []);
    }
  });
  constructor(session: Session) {
    super();
    this.request = new HoldingsRequest(session);
    this.fetchHolding();
    setInterval(() => this.fetchHolding(), 1000 * 60 * 60 * 24); //24 hr interval for fetching holdings
    session.onPostSessionClose(() => this.requestSubscription?.unsubscribe());
  }

  public static getName = () => 'benzinga-holdings';

  public getHoldingsCached = (): Holding[] => this.store.getIndexStoreHoldings();

  public getCachedHoldingByName = (indexName: string): Holding | undefined =>
    this.store.getCachedHoldingByIndexName(indexName);

  protected onFirstSubscription(): void {
    this.requestSubscription = this.request.subscribe(event => this.dispatch(event));
    this.storeSubscription = this.store.subscribe(event => this.dispatch(event));
  }

  protected onZeroSubscriptions(): void {
    this.requestSubscription?.unsubscribe();
    this.storeSubscription?.unsubscribe();
  }
}
